module.exports = __webpack_public_path__ + "static/img/vod-bn-10.84d9913.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vod-bn-10.jpg
// module id = AosG
// module chunks = 1